import Layout from '@/views/platform/Layout.vue';

export default {
    path: '/platform',
    component: Layout,
    children: [
        { path: 'add', component: () => import('@/views/platform/AddPlatform.vue') },
    ]
};
